import { StyleSheet } from 'aphrodite';

const styles = StyleSheet.create({
  root: {},
  driverImg: {
    height: 32,
    width: 32,
    borderRadius: 4,
    marginRight: 16
  },
  driverName: {
    fontWeight: 'bold'
  }
});

export default styles;



// WEBPACK FOOTER //
// ./src/components/available-drivers-list/available-drivers-list-styles.js